module.exports = __webpack_public_path__ + "static/media/flag-yellow.95b78586.jpg";